import classes from './Chatbot.module.css';

const CloudLoadingAnimation = () => {
  const bubblePositions = [
    { position: { x: '5%', y: '0%' } },
    { position: { x: '40%', y: '0%' } },
    { position: { x: '44%', y: '35%' } },
    { position: { x: '25%', y: '46%' } },
    { position: { x: '0%', y: '35%' } },
  ]

  return (
    <div className={classes.cloud_container}>
      {bubblePositions.map((bubble, index) => (
          <div
          key={index}
              className={classes.cloud_bubble}
              style={{
                  left: bubble.position.x,
                  top: bubble.position.y
              }}
          />
      ))}
    </div>
  )
}

export default CloudLoadingAnimation
